// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"254":"66c8eeec","346":"7a589cc3","348":"0d7764f8","409":"5ec4f31b","453":"9206a7d8","489":"3141c608","641":"917ccae2","695":"c89938bf","723":"2aa46973","893":"90508189"}[chunkId] + ".chunk.js";
};